// API가 403 /errors/permission/denied 를 반환하면 권한 컨텍스트가 /me 를 다시 조회하도록 알린다 (spec R-FE-01).
// axios 인터셉터(defaultInstance.js) → notifyIfPermissionDenied → AccessProvider 구독자.

export const PERMISSION_DENIED_TYPE = "/errors/permission/denied";
export const ACCESS_ME_PATH = "/admin/access/me";

const listeners = new Set();

/** @param {() => void} listener @returns {() => void} 구독 해제 함수 */
export function onPermissionDenied(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

/** problem-details type. 일부 응답은 data.data 아래에 둔다. */
export function getProblemType(error) {
  const body = error?.response?.data;
  return body?.type ?? body?.data?.type;
}

/** 403 permission/denied 이면 구독자에게 알린다. /me 자체의 실패로는 알리지 않는다(재조회 루프 방지). */
export function notifyIfPermissionDenied(error) {
  if (error?.response?.status !== 403) return false;
  if (getProblemType(error) !== PERMISSION_DENIED_TYPE) return false;
  if ((error?.config?.url || "").endsWith(ACCESS_ME_PATH)) return false;
  listeners.forEach((listener) => {
    try {
      listener();
    } catch (e) {
      console.error("권한 재조회 알림 실패:", e);
    }
  });
  return true;
}
